import React from "react";
import MyProfile from "./compenents/MyProfile";

const Profile = () => {
    return (
        <MyProfile />
    )
};
export default Profile;